import { ReactNode } from 'react';
import { BoxProps as MuiBoxProps } from '@mui/material/Box';
import { MuiBox } from '../../../../../../../../modules/material';
import { StyledHeading } from './styles';

export interface SecondLevelListWrapperProps extends MuiBoxProps {
  heading?: ReactNode;
}

export default function SecondLevelListWrapper(
  props: SecondLevelListWrapperProps,
) {
  const { heading, children, ...muiBoxProps } = props;

  return (
    <MuiBox {...muiBoxProps}>
      {heading && <StyledHeading>{heading}</StyledHeading>}
      {children}
    </MuiBox>
  );
}
